import { CartItem } from '../../types/product';
import {
  ADD_TO_CART,
  ADD_TO_CART_ERROR,
  DELETE_FROM_CART,
  GET_CART_ITEMS,
  GET_CART_ITEMS_ERROR,
} from '../actions/types';

export interface CartState {
  cart?: CartItem[];
  total?: number;
  count?: number;
  [k: string]: any;
}

export const cartInitialState: CartState = {
  cart: [],
  total: 0,
  count: 0,
};

export const CartReducer = (
  state: CartState = cartInitialState,
  action: {
    type: string;
    payload: CartItem | CartItem[] | { error: boolean; message: string } | null;
  }
) => {
  switch (action.type) {
    case ADD_TO_CART:
      return {
        ...state,
        cart: [...state.cart!, action.payload],
        count: state.count! + 1,
        total:
          state.total! +
          (action.payload as CartItem).count *
            (action.payload as CartItem).product.price,
      };
    case ADD_TO_CART_ERROR:
      return {
        ...state,
        addCartError: action.payload,
      };
    case DELETE_FROM_CART:
      return state;
    case GET_CART_ITEMS:
      let info = (action.payload as CartItem[]).reduce(
        (acc, item) => {
          acc['count'] += 1;
          acc['total'] = acc['total'] + item.count * item.product.price;
          return acc;
        },
        { count: 0, total: 0 } as { count: number; total: number }
      );
      return {
        ...state,
        cart: action.payload as CartItem[],
        count: info.count,
        total: info.total,
      };
    case GET_CART_ITEMS_ERROR:
      return {
        ...state,
        getCartError: action.payload,
      };
    default:
      return state;
  }
};
